import { render, staticRenderFns } from "./VenueCampaignGeneral.vue?vue&type=template&id=0dd3d118&"
import script from "./VenueCampaignGeneral.vue?vue&type=script&lang=js&"
export * from "./VenueCampaignGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports